import { CartUrgencyDS } from '@src/components/blocks/cart-urgency-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { CartUrgencyLegacy } from './cart-urgency-legacy'

export interface CartUrgencyProps {
  className?: string
}

export const CartUrgency = ({ className }: CartUrgencyProps) => {
  if (shouldUseDesignSystem()) {
    return <CartUrgencyDS className={className} />
  }

  return <CartUrgencyLegacy className={className} />
}
